import { MULTI_UPLOAD_FILE_TYPE } from '../../utils'
import {
  SvgDocIcon,
  SvgDocxIcon,
  SvgJpegIcon,
  SvgJpgIcon,
  SvgPngIcon,
  SvgPptIcon,
  SvgPptxIcon,
  SvgTextIcon,
  SvgXlsIcon,
  SvgXlsxIcon,
  OtherDocumentIcon,
} from '../../assets/images'
import SvgPlus from '../../assets/images/components/pdfIcon'
import { FileTypeComponentIconProps } from '../../utils/types/fileUploadTypes'

const FileTypeComponentIcon: React.FC<FileTypeComponentIconProps> = ({
  fileType,
  smallIcon = false,
}) => {
  const classNameForSvg = !smallIcon ? 'w-full h-full' : ''
  switch (fileType) {
    case MULTI_UPLOAD_FILE_TYPE.PDF:
      return <SvgPlus className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.PNG:
      return <SvgPngIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.PPT:
      return <SvgPptIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.PPTX:
      return <SvgPptxIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.DOC:
      return <SvgDocIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.DOCX:
      return <SvgDocxIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.DOCM:
      return <SvgDocxIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.XLS:
      return <SvgXlsIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.XLSX:
      return <SvgXlsxIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.XLSM:
      return <SvgXlsxIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.JPG:
      return <SvgJpgIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.JPEG:
      return <SvgJpegIcon className={classNameForSvg} />
    case MULTI_UPLOAD_FILE_TYPE.TXT:
      return <SvgTextIcon className={classNameForSvg} />
    default:
      return <OtherDocumentIcon className={classNameForSvg} />
  }
}

export default FileTypeComponentIcon
